import { NodeType } from '@vedalib/editor'
import type { ElementsTypes } from '@vedalib/editor/lib/elements'
import { generateId } from '@vedalib/editor/lib/utils/id'

import { DeviceMode } from 'services/Store/Project/enums'

interface IGridProps {
  minHeight: number
  minWidth?: number
  widthType?: string
  heightType: string
}

const gridProps: Partial<Record<ElementsTypes, Record<DeviceMode, IGridProps>>> = {
  simulator: {
    [DeviceMode.desktop]: {
      minHeight: 400,
      minWidth: 800,
      widthType: 'px',
      heightType: 'px',
    },
    [DeviceMode.tablet]: {
      minHeight: 400,
      minWidth: 600,
      widthType: 'px',
      heightType: 'px',
    },
    [DeviceMode.mobile]: {
      minHeight: 400,
      minWidth: 300,
      widthType: 'px',
      heightType: 'px',
    },
  },
  reflection: {
    [DeviceMode.desktop]: {
      minHeight: 240,
      heightType: 'px',
    },
    [DeviceMode.tablet]: {
      minHeight: 240,
      heightType: 'px',
    },
    [DeviceMode.mobile]: {
      minHeight: 240,
      heightType: 'px',
    },
  },
}

export const createColNode = (children: string[] = []) => ({
  id: generateId(),
  type: NodeType.column,
  children: children,
  style: {
    [DeviceMode.desktop]: {},
  },
})
export const createAbsoluteNode = (children: string[] = []) => ({
  id: generateId(),
  type: NodeType.absolute,
  children: children,
  style: {
    [DeviceMode.desktop]: {},
  },
})
export const createRowNode = (children: string[] = []) => ({
  id: generateId(),
  type: NodeType.row,
  children,
  style: {
    [DeviceMode.desktop]: {
      minHeight: 40,
    },
  },
})
export const createShell = (type?: ElementsTypes) => {
  const addProps = type && gridProps[type]

  return {
    id: generateId(),
    type: NodeType.shell,
    [DeviceMode.desktop]: addProps?.[DeviceMode.desktop] ?? {},
    [DeviceMode.tablet]: addProps?.[DeviceMode.tablet] ?? {},
    [DeviceMode.mobile]: addProps?.[DeviceMode.mobile] ?? {},
  }
}
